import { GridCellProps } from '@progress/kendo-react-grid';
import WarningIcon from 'src/assets/icons/WarningIcon';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { getBgColor } from 'src/utils/icons';

const AccountingPeriodWarningCell = (props: GridCellProps) => {
  const { dataItem } = props;

  const { value } = useGridCellDisplayValue(props);
  let { warnings } = dataItem;

  return (
    <GridCellBase {...props}>
      <div className="flex items-center gap-2">
        {value}
        {!!warnings.length && (
          <div
            className={`flex justify-center items-center gap-1 p-1 rounded ${getBgColor(
              [],
              warnings
            )}`}
          >
            <WarningIcon />
            <span className="text-xs">{warnings[0]}</span>
          </div>
        )}
      </div>
    </GridCellBase>
  );
};

export default AccountingPeriodWarningCell;
